import React from 'react';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = () => {
  return (
    <>
      <ToastContainer />
    </>
  );
};

export { ToastMessage };
export const showToast = (msg, type = 'success',autoClose= 2000, position = 'top-right') => {
  toast(msg, { type, autoClose, position, transition: Zoom });
};
